// src/Dashboard/pages/user/Absences/components/AbsenceForm.jsx

import React from "react";
import { FaCalendarAlt, FaSave, FaTimes } from "react-icons/fa";

export default function AbsenceForm({
  form,
  updateForm,
  selectedAdherent,
  saving,
  onSubmit,
  onReset,
}) {
  return (
    <form
      onSubmit={onSubmit}
      className="overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-950"
    >
      <div className="border-b border-slate-200 bg-slate-50 px-4 py-4 dark:border-slate-800 dark:bg-slate-900/60 sm:px-5">
        <h2 className="text-base font-bold text-slate-900 dark:text-white">
          Déclaration d’absence
        </h2>

        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
          Indiquez le statut, une date de reprise estimée et un motif si
          nécessaire.
        </p>
      </div>

      <div className="space-y-5 p-4 sm:p-5">
        <label className="flex w-fit items-center gap-3 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 dark:border-slate-700 dark:bg-slate-900/70">
          <input
            type="checkbox"
            checked={form.isAbsent}
            onChange={(event) =>
              updateForm({
                isAbsent: event.target.checked,
              })
            }
            className="h-4 w-4 accent-indigo-600"
          />

          <span className="text-sm font-bold text-slate-800 dark:text-slate-100">
            Blessé(e) / Malade / Absent(e)
          </span>
        </label>

        <div>
          <label className="mb-1 flex items-center gap-2 text-sm font-bold text-slate-800 dark:text-slate-100">
            <FaCalendarAlt className="text-slate-400" />
            Date de reprise estimée
          </label>

          <input
            type="date"
            value={form.returnDate}
            onChange={(event) =>
              updateForm({
                returnDate: event.target.value,
              })
            }
            className="w-full rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          />
        </div>

        <div>
          <label className="mb-1 block text-sm font-bold text-slate-800 dark:text-slate-100">
            Motif d’absence
          </label>

          <textarea
            rows={4}
            value={form.reason}
            onChange={(event) =>
              updateForm({
                reason: event.target.value,
              })
            }
            placeholder="Ex. : grippe, blessure au genou, déplacement familial..."
            className="w-full resize-none rounded-2xl border border-slate-300 bg-white px-3 py-3 text-sm text-slate-900 outline-none transition placeholder:text-slate-400 focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white dark:placeholder:text-slate-500"
          />
        </div>

        <div className="flex flex-col gap-2 border-t border-slate-200 pt-4 dark:border-slate-800 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onReset}
            disabled={!selectedAdherent || saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FaTimes />
            Réinitialiser
          </button>

          <button
            type="submit"
            disabled={!selectedAdherent || saving}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#013E8E] px-4 py-3 text-sm font-bold text-white transition hover:bg-indigo-800 disabled:cursor-not-allowed disabled:opacity-60"
          >
            <FaSave />
            {saving ? "Enregistrement..." : "Enregistrer l’absence"}
          </button>
        </div>
      </div>
    </form>
  );
}